import { createContext } from "react";

export const NeoAuth0Context = createContext(undefined);
